import './Banner.css';

import React from 'react'

function Banner() {
    return (
        <div className="banner">
            {/* <div className="overlay"></div> */}
            <video autoPlay={true} muted="" loop={true}>
                <source src="./videos/banner_video.mov" type="video/mp4" />
            </video>
        </div>
    )
}

export default Banner
